import { SelectionModel } from '@angular/cdk/collections';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { ImportDialogComponent } from '../import-dialog/import-dialog.component';
import { FileErrorPopupComponent } from '../file-error-popup/file-error-popup.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { AppService } from 'src/app/app.service';
import { AddRateTableComponent } from '../add-rate-table/add-rate-table.component';
import * as JSZip from 'jszip';
import { Router } from '@angular/router';
import { share, take } from 'rxjs';

@Component({
  selector: 'app-agreement-rate-table',
  templateUrl: './agreement-rate-table.component.html',
  styleUrls: ['./agreement-rate-table.component.scss'],
})
export class AgreementRateTableComponent
  implements AfterViewInit, OnChanges, OnInit
{
  agreementData: any;
  public operation: any;
  rateTableForm: FormGroup = new FormGroup({});

  selectedColumn: any;
  // appService.selectedItem:any=0;
  userData: any;
  transportModeList: any;
  rateTableTypeList: any;
  carrierGSDBList: any;
  bidpackRefList: any;
  bidpackActualList: any;
  imscSideList: any;
  isMatrixSelected: boolean = false;
  public countryListArr: any;
  public remarksRemainingChar: number = 9000;
  public isRemarks: boolean = false;
  files: any;
  public maxEnterCount = 10;

  rateTableId = 0;

  testSubsciber: any;
  fuelFlagSelected: string = 'No';
  applyRateCahnge = 0;

  // @ViewChild('remark') remark!:ElementRef;
  // @ViewChild('remark', {static:false}) remark:any;
  @ViewChild('ftlComp', { static: false }) ftlComp: any;
  @ViewChild('ltlComp', { static: false }) ltlComp: any;
  @ViewChild('fixedComp', { static: false }) fixedComp: any;
  @ViewChild('additionComp', { static: false }) additionComp: any;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @Input() copyActivity: boolean = false;

  constructor(
    public dialog: MatDialog,
    public appService: AppService,
    private httpService: HttpService,
    private router: Router
  ) {
    this.rateTableForm = new FormGroup({
      rateTable: new FormControl('', Validators.required),
      bpReference: new FormControl('', Validators.required),
      gsdb: new FormControl('', Validators.required),
      rateTableType: new FormControl('', Validators.required),
      bpOriginRegion: new FormControl('', Validators.required),
      bpOriginPostcode: new FormControl(''),
      bpDestination: new FormControl('', Validators.required),
      transMode: new FormControl('', Validators.required),
      fuelFlag: new FormControl('', Validators.required),
      excludingVat: new FormControl(''),
      version: new FormControl(''),
      fuelPrice: new FormControl(''),
      countryFuelPrice: new FormControl(0),
      costBaseline: new FormControl(null),
      costBreakdown: new FormControl(null),
      fuelTrigger: new FormControl(null, Validators.required),
      comment: new FormControl(''),
      rateChange: new FormControl(0, [
        Validators.pattern(/^-?\d+(\.\d{0,2})?$/),
      ]),
      remark: new FormControl('', Validators.required),
    });

    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    this.agreementData = history.state.data;
    this.operation = history.state.operation;

    let id = sessionStorage.getItem('raID');
    let raId: number = id ? +id : 0;

    if (this.operation != 'add') {
      if (this.userData.RoleID != 4) {
        this.operation = 'view';
      } else {
        if (raId !== 39) {
          this.operation = 'view';
        }
      }
    } else {
      this.rateTableForm.enable();
    }

    this.getRateTableList();
    this.getContactType();
    this.getBidpackList();
    this.getCarrierList();
    this.getCountryList();

    this.isMatrixSelected = false;
    this.appService.matrixSubscriber = this.appService.matrixEmitter.subscribe(
      (evt: string) => {
        this.isMatrixSelected = true;
        this.appService.rateTableSave = false;
        this.toPushNewData(evt);
        // this.appService.matrixSubscriber.unsubscribe();
      }
    );

    this.appService.testSubsciber = this.appService.testEvtEMit
      .pipe(share())
      .subscribe((evt: string) => {
        this.isMatrixSelected = true;
        this.appService.rateTableSave = false;
        appService.emitCOunt = false;
        this.toPushNewData(evt);
      });

    this.appService.saveSubscrier =
      this.appService.rateAgreementSaveemit.subscribe((evt: any) => {
        if (evt === null) {
          // edit...
          this.onSave();
          return;
        } else {
          // add
          // this.copyActivity = evt.copy;
          this.appService.rateOutputData.forEach((i: any) => {
            i.RateAgreementTableID = Number(evt.id);
          });
          this.onSave();
        }
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      Object.keys(this.rateTableForm.controls).forEach((controlName) => {
        this.rateTableForm
          .get(controlName)!
          .valueChanges.subscribe((value: any) => {
            this.appService.onRAvalueChanged = true;
          });
      });
    }, 2000);
  }

  ngOnInit(): void {
    this.appService.gsdbToTableEmit.subscribe((obj: any) => {
      sessionStorage.setItem('carrierID', obj);
      let resulet = this.carrierGSDBList.find((i: any) => i.CarrierID === +obj);
      if (resulet) {
        this.imscSideList = resulet.IMCSSiteCode.split(';');
        // this.rateTableForm.get('gsdb')?.setValue('');
        // if(this.imscSideList.length===1){
        //   this.rateTableForm.patchValue({
        //     gsdb: this.imscSideList[0]
        //   })
        // }
      }
    });
  }

  public shouldShowAdditionalCharges(): boolean {
    const rateTableTypeID =
      this.appService.rateTableList[this.appService.selectedItem]
        ?.RateTableTypeID;
    return rateTableTypeID === 43 || rateTableTypeID === 42;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['copyActivity']?.currentValue) {
      this.copyActivity = changes['copyActivity']?.currentValue;
      if (this.imscSideList.length === 1) {
        this.rateTableForm.patchValue({
          gsdb: this.imscSideList[0],
        });
      }

      this.appService.rateDateSource.forEach((element: any) => {
        let item = this.bidpackRefList.find(
          (i: any) =>
            i.BidPackReference === element.BidPackReference &&
            i.BidPackStatusID !== 58
        );
        if (item) {
          element.BidPackID = item.BidPackID;
          element.BidPackReference = item.BidPackReference;
          element.BidPackOriginCountry = item.OriginCountry;
          element.BidPackOriginZipCode = item.BidPackOriginZipCode;
          element.BidPackOriginZipCodeArea = item.BidPackOriginZipCodeArea;
          element.BidPackDestinationName = item.DestinationName;
          this.appService.rateOutputData.forEach((i: any) => {
            if (i.RateTableID === element.RateTableID) {
              i.BidPackID = item.BidPackID;
            }
          });
        } else {
          this.rateTableForm.patchValue({
            bpReference: '',
            bpOriginRegion: '',
            bpOriginPostcode: '',
            bpDestination: '',
          });

          this.appService.rateDateSource[
            this.appService.selectedItem
          ].BidPackOriginCountry = '';
          this.appService.rateDateSource[
            this.appService.selectedItem
          ].BidPackOriginZipCodeArea = '';
          this.appService.rateDateSource[
            this.appService.selectedItem
          ].BidPackDestinationName = '';
          this.appService.rateDateSource[
            this.appService.selectedItem
          ].BidPackID = null;
          this.appService.updateValueToRateTable(
            'BidPackID',
            this.appService.selectedItem
          );

          element.BidPackID = null;
          element.BidPackReference = '';
          element.BidPackOriginCountry = '';
          element.BidPackOriginZipCode = '';
          element.BidPackOriginZipCodeArea = '';
          element.BidPackDestinationName = '';
          this.appService.rateOutputData.forEach((i: any) => {
            if (i.RateTableID === element.RateTableID) {
              i.BidPackID = null;
            }
          });
        }
      });
      // BidPackReference
      // this.selectedColumn =0;
      // this.appService.selectedItem= 0;
      let data = this.appService.rateDateSource[this.appService.selectedItem];
      let item1 = this.bidpackRefList.find(
        (i: any) =>
          i.BidPackReference === data.BidPackReference &&
          i.BidPackStatusID !== 58
      );
      if (item1) {
        this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
          item1.BidPackID;

        // this.onOptionChange({value:item1.BidPackID},'bpReference')
        let selected = item1;
        this.rateTableForm.patchValue({
          bpReference: item1.BidPackID,
          bpOriginRegion: this.onBPRegion(selected, 'OriginCountry'),
          bpOriginPostcode: this.onBPRegion(
            selected,
            'BidPackOriginZipCodeArea'
          ),
          bpDestination: selected.DestinationName,
        });
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginCountry = selected.OriginCountry;
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginZipCodeArea = selected.BidPackOriginZipCodeArea;
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackDestinationName = selected.DestinationName;
        this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
          item1.BidPackID;
        this.appService.updateValueToRateTable(
          'BidPackID',
          this.appService.selectedItem
        );
      } else {
        this.rateTableForm.patchValue({
          bpReference: '',
          bpOriginRegion: '',
          bpOriginPostcode: '',
          bpDestination: '',
        });
      }
      this.operation = 'edit';
      this.rateTableForm.enable();

      // this.appService.rateTableList.forEach((item:any, ind:number) => {
      //   // item.RateTableID = 0;
      //   // item.RateAgreementTableID = null;
      // });

      //     this.appService.rateDateSource.forEach((element:any) => {
      //       element.RateAgreementTableID = 0;
      //       element.RateTableID =0
      //    });
      //    this.appService.rateTableList.forEach((element:any) => {
      //     element.RateAgreementTableID = 0;
      //     element.RateTableID =0
      //  });
    }
  }

  remarksRemainingChars(event: any) {
    this.isRemarks = true;
    const inputValue = event.target.value;
    const inputLength = inputValue.length;
    this.remarksRemainingChar = 9000 - inputLength;

    setTimeout(() => {
      this.isRemarks = false;
    }, 5000);

    if (inputLength < this.maxEnterCount) return;

    this.validateTextArea(inputValue);
  }

  private validateTextArea(inputValue: string): void {
    const lines = inputValue.split('\n');

    if (this.hasTooManyEmptyLines(lines)) {
      this.httpService.openSnackBar(
        'Too many empty lines detected. Please reduce blank lines'
      );
      return;
    }

    if (this.hasRepeatedLines(lines)) {
      this.httpService.openSnackBar('Same content appears on multiple lines');
      return;
    }
  }

  private hasRepeatedLines(lines: string[]): boolean {
    if (lines.length <= 1) return false;

    const nonEmptyLines = lines.filter((line) => line.trim() !== '');
    if (nonEmptyLines.length === 0) return false;

    return this.checkLineRepetitionFrequency(nonEmptyLines);
  }

  private checkLineRepetitionFrequency(nonEmptyLines: string[]): boolean {
    const lineFrequency: { [key: string]: number } = {};

    nonEmptyLines.forEach((line) => {
      const trimmedLine = line.trim();
      if (trimmedLine.length > 1) {
        lineFrequency[trimmedLine] = (lineFrequency[trimmedLine] || 0) + 1;
      }
    });

    for (const line in lineFrequency) {
      const percentage = (lineFrequency[line] / nonEmptyLines.length) * 100;
      if (percentage > 50 && nonEmptyLines.length > 2) {
        return true;
      }
    }

    return false;
  }

  private hasTooManyEmptyLines(lines: string[]): boolean {
    if (lines.length <= 1) return false;

    const emptyLines = lines.filter((line) => line.trim() === '');
    const emptyLinePercentage = (emptyLines.length / lines.length) * 100;
    return emptyLinePercentage > 50;
  }

  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.countryListArr = res;
        this.appService.countryListArr = this.countryListArr;
        this.countryListArr.sort((a: any, b: any) =>
          a.CountryName.toLowerCase() > b.CountryName.toLowerCase() ? 1 : -1
        );
      }
    });
  }

  onListselection(i: any, select = true) {
    //   this.appService.ltlRateChangeSub?.unsubscribe();
    //   this.appService.ftlRateChangeSub?.unsubscribe();
    //   this.appService.fixedRateChangeSub?.unsubscribe();
    this.appService.raIsLoading = true;
    this.selectedColumn = this.appService.rateTableList[i].RateTableID;
    this.rateTableId = this.appService.rateTableList[i].RateTableID;
    this.appService.selectedItem = i;
    this.bidpackRefList = this.bidpackActualList;
    this.toUpdateOnField();
    if (select) {
      setTimeout(() => {
        this.appService.raIsLoading = false;
      }, 700);
    }
    // this.onAttachFile();
    // this.appService.matrixDataEmit.emit({id:this.appService.rateTableList[i].RateTableID,type:this.appService.rateTableList[i].RateTableTypeID})
  }

  onAttachFile() {
    // if(this.operation === 'add'){
    //   return;
    // }
    // return;

    // this.appService.isLoading = true;
    this.httpService
      .getRateFileFromBlob(
        'version',
        this.appService.rateTableList[0].RateAgreementTableID
          ? this.appService.rateTableList[0].RateAgreementTableID
          : 0,
        this.appService.selectedItem
      )
      .subscribe((blob: Blob) => {
        // const zipFilename = 'files.zip';
        // saveAs(blob, zipFilename); // download as zip file
        if (blob.type === 'text/html') {
          return;
        }
        const zipReader = new FileReader();
        zipReader.onload = () => {
          const zipData = zipReader.result as ArrayBuffer;
          this.extractFilesFromZip(zipData);
        };
        zipReader.readAsArrayBuffer(blob);
      });
  }

  private extractFilesFromZip(zipData: ArrayBuffer): void {
    const zip = new JSZip();

    zip.loadAsync(zipData).then((zip: any) => {
      zip.forEach((relativePath: any, zipEntry: any) => {
        zipEntry.async('blob').then((fileData: any) => {
          const inputElement = this.fileInput?.nativeElement;
          if (inputElement) inputElement.type = 'file';
          this.files = [new File([fileData], zipEntry.name)];
        });
      });
    });
  }

  onSave() {
    // this.appService.saveSubscrier.unsubscribe();
    if (!this.rateTableForm.value) {
      this.httpService.openSnackBar('Please create atleast a table');
      return;
    }
    // if(this.rateTableForm.invalid){
    //   this.appService.saveSubscrier.unsubscribe();
    //   return;
    // }
    // if(!this.appService.raSAve)
    //   return;
    if (this.operation === 'edit' && this.appService.copyActivity) {
      this.appService.rateOutputData.forEach((i: any) => {
        i.RateTableID = null;
      });
    }
    // return
    this.appService.isLoading = true;
    this.httpService
      .setRateTable(this.appService.rateOutputData)
      .subscribe((res: any) => {
        this.appService.isLoading = false;
        this.appService.raIsLoading = false;
        if (res) {
          this.appService.raSAve = false;
          this.httpService.openSnackBar('Rate table is Updated Successfully');
          this.appService.rateTableSave = true;
          if (this.appService.approveBtnClicked) {
            this.httpService
              .onApprove(
                this.agreementData.RateAgreementID,
                this.userData.UserID
              )
              .subscribe((res: any) => {
                // ['version','attachment'].forEach((i:any) =>{
                // this.httpService.onApprovalRename(i,this.dataSource.RateAgreementID,res[0].RateAgreementID)
                // .subscribe((res:any) =>{
                //   console.log("res.......",res);
                // })
                // })
                if (res[0]?.DuplicateFlag === 1) {
                  this.httpService.openSnackBar(
                    'Combination of RA Number, Effective Date and Expiry Date already exists'
                  );
                } else if (res[0]?.DuplicateFlag === 2) {
                  this.httpService.openSnackBar(
                    'Effective Date of the Rate Agreement should be Today or Greater'
                  );
                } else if (res[0]?.DuplicateFlag === 3) {
                  this.httpService.openSnackBar(
                    'Two different versions of the Rate Agreement cannot have same Effective Date as Today'
                  );
                } else if (res[0]?.DuplicateFlag === 4) {
                  this.httpService.openSnackBar(
                    'Draft version with lower preceeding Revision Number exists for this Rate Agreement'
                  );
                } else {
                  this.httpService.openSnackBar(
                    'Rate Agreement Approved Successfully'
                  );
                  this.router.navigateByUrl('/home/rate-agreement');
                }
              });
          } else {
            if (this.operation === 'add' && this.files.length > 0) {
              this.renameFileUpload();
            }
            // this.appService.rateOutputData = [];
            // this.appService.rateDateSource=[];
            // this.appService.rateTableList=[]
            this.router.navigateByUrl('/home/rate-agreement');
          }
          // return;
        }
      });
  }

  renameFileUpload() {
    this.appService.isLoading = true;
    this.httpService
      .onRenameFiles(this.appService.rateOutputData[0].RateAgreementTableID)
      .subscribe((res: any) => {
        this.appService.isLoading = true;
      });
  }

  updateToDataSource() {
    let id = sessionStorage.getItem('carrierID');
    let carrId: number = id ? +id : 0;
    (this.appService.rateDateSource[this.appService.selectedItem].RateTableID =
      this.operation === 'add'
        ? null
        : this.appService.rateTableList[this.appService.selectedItem]
            .RateTableID
        ? this.appService.rateTableList[this.appService.selectedItem]
            .RateTableID
        : null),
      (this.appService.rateDateSource[
        this.appService.selectedItem
      ].RateAgreementTableID = this.appService.rateDateSource[0]
        .RateAgreementTableID
        ? this.appService.rateDateSource[0].RateAgreementTableID
        : null);
    this.appService.rateDateSource[this.appService.selectedItem].RateTableName =
      this.rateTableForm.get('rateTable')?.value;
    this.appService.rateDateSource[this.appService.selectedItem].CarrierID =
      +carrId;
    this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
      this.rateTableForm.get('bpReference')?.value
        ? +this.rateTableForm.get('bpReference')?.value
        : null;
    this.appService.rateDateSource[this.appService.selectedItem].IMCSSiteCode =
      this.rateTableForm.get('gsdb')?.value;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].TransportModeID = this.rateTableForm.get('transMode')?.value
      ? +this.rateTableForm.get('transMode')?.value
      : null;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].RateTableTypeID = +this.rateTableForm.get('rateTableType')?.value;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FuelEscalatorFlag =
      this.rateTableForm.get('fuelFlag')?.value === 'Yes' ? true : false;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FuelEscalatorVersion = this.appService.escapeSingleQuotes(
      this.rateTableForm.get('version')?.value
    );
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FuelCostBaseline = +this.rateTableForm.get('costBaseline')?.value;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].DataSourceForFuelPrice = this.appService.escapeSingleQuotes(
      this.rateTableForm.get('fuelPrice')?.value
    );
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].CountryForFuelPriceID =
      +this.rateTableForm.get('countryFuelPrice')?.value;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FuelCostBreakdown = +this.rateTableForm.get('costBreakdown')?.value;
    this.appService.rateDateSource[this.appService.selectedItem].FuelTrigger =
      +this.rateTableForm.get('fuelTrigger')?.value;
    this.appService.rateDateSource[this.appService.selectedItem].ExcludingVAT =
      this.rateTableForm.get('excludingVat')?.value === 'Yes' ? true : false;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FuelEscalatorComment = this.appService.escapeSingleQuotes(
      this.rateTableForm.get('comment')?.value
    );
    this.appService.rateDateSource[this.appService.selectedItem].RateChange =
      +this.rateTableForm.get('rateChange')?.value;
    this.appService.rateDateSource[this.appService.selectedItem].Remarks =
      this.appService.escapeSingleQuotes(
        this.rateTableForm.get('remark')?.value
      );
    this.appService.rateDateSource[this.appService.selectedItem].UserEmail =
      this.userData.Email;
    this.appService.updateDataToDB();
  }

  onOverallExport(type: string) {
    this.appService.rateTableList.forEach((item: any, ind: number) => {
      if (item.RateTableTypeID === 42 && ind === this.appService.selectedItem) {
        // //ftl
        // this.ftlComp.onExportdata();
        // this.additionComp.onExportData();
        this.appService.rateExportEmit.emit({ type: 'ftl', format: type });
      } else if (
        item.RateTableTypeID === 44 &&
        ind === this.appService.selectedItem
      ) {
        // ltl
        this.appService.rateExportEmit.emit({ type: 'ltl', format: type });
        // this.ltlComp.onExportdata();
      } else if (
        item.RateTableTypeID === 43 &&
        ind === this.appService.selectedItem
      ) {
        // ltl
        this.appService.rateExportEmit.emit({ type: 'fixed', format: type });
        // this.ltlComp.onExportdata();
      }
    });
  }

  onAddNewTable() {
    this.appService.onRAvalueChanged = true;
    const dialogRef = this.dialog.open(AddRateTableComponent, {
      disableClose: false,
      data: { operation: 'popup' },
    });
  }

  onNumberInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    let value = inputElement.value;
    const regex = /^\d+(\.\d{0,2})?$/;
    if (!regex.test(value)) {
      const trimmedValue = parseFloat(value).toFixed(2);
      inputElement.value = isNaN(+trimmedValue) ? value : trimmedValue;
    }
  }

  restrictFloatInput(input: any) {
    const value = input.value;
    const regex = /^-?\d+(\.\d{0,2})?$/;

    if (!regex.test(value)) {
      input.value = value.slice(0, -1);
    }
  }

  getRateTableList() {
    if (this.operation === 'add') {
      this.selectedColumn = 0;
      this.appService.selectedItem = 0;
      return;
    }
    this.appService.isLoading = true;
    this.httpService
      .getRateTableList(this.agreementData.RateAgreementID)
      .subscribe((res: any) => {
        this.appService.raIsLoading = false;
        if (res.length > 0) {
          this.appService.rateTableList = [];
          this.appService.rateTableList = [...res];
          this.appService.rateTableList.sort(
            (a: any, b: any) => a.orderId - b.orderId
          );
          this.appService.emitCOunt = true;
          this.appService.rateTableList.forEach((i: any, ind: any) => {
            this.selectedColumn = i.RateTableID;
          });
          this.getRateTableData();
          this.onGetOutputDataForTable();
          this.selectedColumn = this.appService.rateTableList[0].RateTableID;
          this.appService.selectedItem = 0;
          this.onListselection(0, false);
        } else {
          this.appService.rateTableList = [];
          this.selectedColumn = 0;
          this.appService.selectedItem = 0;
          this.isMatrixSelected = false;
          this.operation = 'add';
          this.httpService.openSnackBar(
            'No Rate Table is associated with this Rate Agreement'
          );
        }
      });
  }

  getContactType() {
    this.appService.isLoading = true;
    this.httpService.getListOfData('Rate').subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.transportModeList = res.filter(
          (item: any) => item.Category === 'TransportMode'
        );
        this.rateTableTypeList = res.filter(
          (item: any) => item.Category === 'RateTableTypes'
        );
      }
    });
  }

  getBidpackList() {
    this.appService.isLoading = true;
    this.httpService.getBidpackDetails().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.bidpackActualList = res;
        this.bidpackRefList = res;
      }
    });
  }

  getCarrierList() {
    this.appService.isLoading = true;
    this.httpService.getCarrierDetails().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.carrierGSDBList = res; //.filter((i:any) => i.Status === "Active");
        this.carrierGSDBList.sort((a: any, b: any) =>
          a.ContractGSDB.toLowerCase() > b.ContractGSDB.toLowerCase() ? 1 : -1
        );
        if (this.operation != 'add') {
          let id = sessionStorage.getItem('carrierID');
          let carrId: number = id ? +id : 0;
          let resulet = this.carrierGSDBList?.find(
            (i: any) => i.CarrierID === +carrId
          );
          if (resulet) {
            this.imscSideList = resulet.IMCSSiteCode?.split(';');
            if (this.imscSideList.length === 1) {
              this.rateTableForm.patchValue({
                gsdb: this.imscSideList[0],
              });
            }
          }
        }
      }
    });
  }

  toUpdateOnField() {
    this.appService.isLoading = true;
    this.rateTableForm.enable();
    this.files = [];
    if (this.operation === 'add') {
      this.rateTableForm.patchValue({
        createdBy: this.userData.Email,
        modifiedDate: this.appService.getToday(),
        createdDate: this.appService.getToday(),
        modifiedBy: this.userData.Email,
        countryFuelPrice: '',
        gsdb: '',
        bpReference: '',
        transMode: '',
      });
      this.formPatchValue(this.appService.selectedItem);
      return;
    }
    if (this.operation === 'view') {
      this.rateTableForm.disable();
      this.rateTableForm.disable();
    }
    this.formPatchValue(this.appService.selectedItem);
  }

  toPushNewData(evt: string) {
    this.appService.selectedItem = this.appService.rateTableList.length;
    this.files = [];
    let item = {
      RateTableID: 0,
      RateAgreementTableID:
        this.operation === 'add'
          ? null
          : this.appService.rateTableList[0]?.RateAgreementTableID,
      RateTableName:
        evt +
        '_' +
        (this.appService.rateTableList
          ? this.appService.rateTableList.length
          : 1),
      RateTableTypeID: evt === 'ftl' ? 42 : evt === 'ltl' ? 44 : 43,
      RateTableType:
        evt === 'ftl'
          ? 'FTL Matrix'
          : evt === 'ltl'
          ? 'LTL Matrix'
          : 'FTL(Fixed Price) Matrix',
    };
    let i = 0;
    if (this.appService.rateTableList.length > 0) {
      this.appService.rateTableList.push(item);
      i = this.appService.rateTableList.length - 1;
      this.appService.selectedItem = i;
    } else {
      this.appService.rateTableList = [];
      this.appService.rateTableList.push(item);
      this.appService.selectedItem = 0;
    }
    let agreementId =
      this.appService.rateDateSource[0]?.RateAgreementTableID === null
        ? 0
        : this.appService.rateDateSource[0]?.RateAgreementTableID;
    let obj = {
      RateTableID: null,
      RateTableName: item.RateTableName,
      RateAgreementTableID:
        agreementId === 0 || agreementId === null ? null : agreementId,
      RateTableType: item.RateTableType,
      BidPackID: 0,
      CarrierID: 0,
      IMCSSiteCode: '',
      TransportModeID: 0,
      RateTableTypeID: item.RateTableTypeID,

      FuelEscalatorFlag: false,
      FuelEscalatorVersion: '',
      FuelCostBaseline: 0,
      DataSourceForFuelPrice: '',
      CountryForFuelPriceID: 0,

      FuelCostBreakdown: 0,
      FuelTrigger: 0,
      FuelEscalatorComment: '',
      ExcludingVAT: false,
      RateChange: 0,
      Remarks: '',
      orderId: i,
    };

    // if(this.imscSideList.length===1){
    //   this.rateTableForm.patchValue({
    //     gsdb: this.imscSideList[0]
    //   })
    // }
    this.appService.rateDateSource.push(obj);
    if (!this.appService.rateDateSource[i]) {
      this.appService.rateDateSource[i] = obj;
    }
    this.rateTableForm.reset();
    this.formPatchValue(i);
  }

  formPatchValue(i: number) {
    let obj = this.appService.rateDateSource[i];

    // this.rateTableForm.reset();
    if (this.bidpackRefList?.length === 1) {
      this.rateTableForm.patchValue({
        bpReference: +this.bidpackRefList[0].BidPackID,
      });
      // this.onOptionChange({value:this.bidpackRefList[0].BidPackID},'bpReference')
      let selected = this.bidpackRefList[0];
      this.rateTableForm.patchValue({
        bpOriginRegion: this.onBPRegion(selected, 'OriginCountry'),
        bpOriginPostcode: this.onBPRegion(selected, 'BidPackOriginZipCodeArea'),
        bpDestination: selected.DestinationName,
      });
    }

    this.rateTableForm.patchValue({
      rateTable: obj?.RateTableName ? obj.RateTableName : '',
      bpReference:
        obj?.BidPackID === null || obj?.BidPackID === 0 ? '' : obj?.BidPackID,
      gsdb: obj?.IMCSSiteCode,
      rateTableType: obj?.RateTableTypeID,
      bpOriginRegion: obj?.BidPackOriginCountry
        ? this.onBPRegion(obj, 'BidPackOriginCountry')
        : '',
      bpOriginPostcode: obj?.BidPackOriginZipCodeArea
        ? this.onBPRegion(obj, 'BidPackOriginZipCodeArea')
        : '',
      // bpOriginRegion: this.onBPRegion(obj,'BidPackOriginCountry'),
      // bpOriginPostcode: this.onBPRegion(obj,'BidPackOriginZipCodeArea'),

      bpDestination: obj?.BidPackDestinationName,
      transMode:
        obj?.TransportModeID === null || obj?.TransportModeID === 0
          ? ''
          : obj?.TransportModeID,
      fuelFlag: obj?.FuelEscalatorFlag ? 'Yes' : 'No',
      excludingVat: obj?.ExcludingVAT ? 'Yes' : 'No',
      version: this.appService.deResingDoubleQuotess(obj?.FuelEscalatorVersion),
      fuelPrice: this.appService.deResingDoubleQuotess(
        obj?.DataSourceForFuelPrice
      ),
      countryFuelPrice:
        obj?.CountryForFuelPriceID === null || obj?.CountryForFuelPriceID === 0
          ? ''
          : obj?.CountryForFuelPriceID,

      costBaseline: obj?.FuelCostBaseline ? obj.FuelCostBaseline : null,
      costBreakdown: obj?.FuelCostBreakdown ? obj.FuelCostBreakdown : null,
      fuelTrigger: obj?.FuelTrigger ? obj.FuelTrigger : null,
      comment: this.appService.deResingDoubleQuotess(obj?.FuelEscalatorComment),
      rateChange: obj?.RateChange,
      remark: this.appService.deResingDoubleQuotess(
        obj?.Remarks ? obj.Remarks : ''
      ),
    });
    this.fuelFlagSelected = obj?.FuelEscalatorFlag ? 'Yes' : 'No';
    [
      'excludingVat',
      'fuelPrice',
      'countryFuelPrice',
      'costBaseline',
      'costBreakdown',
      'fuelTrigger',
      'version',
    ].forEach((i: any) => {
      this.setAndRemoveValidator(
        i,
        this.fuelFlagSelected === 'No' ? false : true
      );
    });

    setTimeout(() => {
      this.appService.isLoading = false;
    }, 500);
    // this.appService.setRateTableData(obj, i, this.appService.rateTableList[i].RateTableType);
  }

  onBPRegion(item: any, key: string) {
    const originCountryArray = item[key]
      .split(',')
      .filter((value: any) => value.trim() !== '');
    const uniqueOriginCountryArray = [...new Set(originCountryArray)];
    return uniqueOriginCountryArray.join(',');
  }

  onFieldValue(e: any) {
    // if(e.name === 'remark'){
    //   e.value = this.remark.nativeElement.value
    // }
    this.rateTableForm.patchValue({
      [e.name]: e.value,
    });
    this.updateToDataSource();
    if (e.name === 'rateTable') {
      this.appService.rateTableList[
        this.appService.selectedItem
      ].RateTableName = e.value;
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].RateTableName = e.value;
    }
  }

  onDeleteRateTable() {
    this.appService.onRAvalueChanged = true;
    // this.appService.rateDateSource.splice(this.appService.selectedItem,1);
    this.appService.rateTableList = this.appService.rateTableList.filter(
      (item: any, ind: number) => ind !== this.appService.selectedItem
    );
    this.appService.rateDateSource = this.appService.rateDateSource.filter(
      (item: any, ind: number) => ind !== this.appService.selectedItem
    );
    this.appService.rateOutputData = this.appService.rateOutputData.filter(
      (item: any, ind: number) => item.orderId !== this.appService.selectedItem
    );
    this.appService.rateBackUpData = this.appService.rateBackUpData.filter(
      (item: any, ind: number) => ind !== this.appService.selectedItem
    );

    this.appService.rateTableList.sort(
      (a: any, b: any) => a.orderId - b.orderId
    );
    this.appService.rateTableList.forEach((item: any, index: any) => {
      item.orderId = index;
    });

    this.appService.rateDateSource.sort(
      (a: any, b: any) => a.orderId - b.orderId
    );
    this.appService.rateDateSource.forEach((item: any, index: any) => {
      item.orderId = index;
    });
    // this.appService.rateDateSource = this.appService.rateDateSource.map((item:any, index:any) => {
    //   return { item.orderId:index,...item}; });

    this.appService.rateTableList.forEach((i: any) => {
      this.appService.rateOutputData.forEach((k: any) => {
        if (i.RateTableID && k.RateTableID && i.RateTableID === k.RateTableID) {
          return (k.orderId = i.orderId);
        } else if (
          !i.RateTableID &&
          !k.RateTableID &&
          i.RateTableName === k.RateTableName
        ) {
          return (k.orderId = i.orderId);
        }
      });
    });

    if (this.files.length > 0) {
      this.checkOnFileOrders();
    }
    if (this.appService.rateTableList.length === 0) {
      this.isMatrixSelected = false;
      this.operation = 'add';
    } else {
      this.appService.selectedItem = 0;
      this.selectedColumn = this.appService.rateTableList[0].RateTableID;
      this.toUpdateOnField();
    }
  }

  checkOnFileOrders() {
    this.appService.isLoading = true;
    this.httpService
      .onReOrderFiles(
        this.appService.rateOutputData[0].RateAgreementTableID
          ? this.appService.rateOutputData[0].RateAgreementTableID
          : 0,
        this.appService.selectedItem
      )
      .subscribe((res: any) => {
        this.appService.isLoading = false;
      });
  }
  onAddAgreement() {}
  onImportFile() {
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((evt) => {});
  }
  onExportFile() {
    const dialogRef = this.dialog.open(FileErrorPopupComponent, {
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((evt) => {
      if (evt?.operation === 'try') {
        this.onImportFile();
      }
    });
  }

  getRateTableData() {
    // if(this.selectedColumn === 0){
    //   this.onAttachFile();
    //   this.toUpdateOnField();
    //   return;
    // }
    // if(this.appService.selectedItem < this.appService.rateDateSource.length){
    //   this.onAttachFile();
    //   this.toUpdateOnField();
    //   return;
    // }
    this.appService.rateTableList.forEach((i: any, ind: any) => {
      // this.selectedColumn=i.RateTableID
      this.appService.isLoading = true;
      this.httpService.getRateTable(i.RateTableID).subscribe((res: any) => {
        this.appService.isLoading = false;
        if (res.length > 0) {
          // res = {orderId:i.orderId, ...res[0]}

          if (i.orderId != null || i.orderId !== undefined) {
            this.appService.rateDateSource.push(res[0]);
            // console.log("i.orderId",i.orderId, i.RateTableName, res[0].RateTableName, res[0].orderId);
            // if((i.orderId === res[0].orderId)&& ((i.RateTableName).toLowerCase() === (res[0].RateTableName).toLowerCase())){
            //   this.appService.rateDateSource[i.orderId]=res[0];
            // }
            // else{
            //   this.appService.rateDateSource[res[0].orderId]=res[0];
            // }
            // this.appService.rateDateSource[i.orderId]=res[0];
          } else {
            let id = this.appService.rateDateSource.findIndex(
              (item: any) => item?.RateTableName === res[0].RateTableName
            );
            res = { orderId: id, ...res[0] };
            this.appService.rateDateSource[id] = res;
          }
        }
        this.appService.rateDateSource = this.appService.rateDateSource.sort(
          (a: any, b: any) => a.orderId - b.orderId
        );
      });
    });

    setTimeout(() => {
      this.appService.rateDateSource.sort(
        (a: any, b: any) => a.orderId - b.orderId
      );
      this.onGetOutputDataForTable();
      // this.onAttachFile();
      this.toUpdateOnField();
    }, 1000);
  }

  onGetOutputDataForTable() {
    this.appService.rateTableList.forEach((i: any, ind: any) => {
      this.appService.isLoading = false;
      let tableId = i.RateTableID;
      let type = i.RateTableTypeID;
      if (type === 44) {
        //ltl
        this.httpService.getLTLTable(tableId).subscribe((res: any) => {
          if (res.length > 0) {
            const updatedArray = res.map((obj: any) => {
              const { Weight, Cost, ...rest } = obj;
              return { LTLWeight: Weight, LTLCost: Cost, ...rest };
            });
            this.appService.setRateTableData(updatedArray, ind, 'ltl');
            this.appService.exportTableFormatForLTL(res, ind);
          }
        });
      } else if (type === 42) {
        //ftl
        this.httpService.getFTLTable(tableId).subscribe((res: any) => {
          if (res.length > 0) {
            let mautData: any = this.appService.onMautcountry(
              res[0].MautCountryCost,
              res[0].MautCountry
            );
            const updatedArray = res.map((obj: any) => {
              const { Weight, FTLMatrixCost, MautCountryCost, ...rest } = obj;

              // let mautCountry = (obj.MautCountry)?.split(",")
              return {
                FTLWeight: Weight,
                FTLCost: FTLMatrixCost,
                MautCost: mautData.cost,
                CountryID: mautData.item,
                ...rest,
              };
            });

            // MautCountry
            // this.checOnAddiitonalCharge(updatedArray,ind, tableId)

            let seleected = this.appService.rateDateSource.findIndex(
              (item: any) => item?.RateTableID === tableId
            );
            // if(seleected){
            this.appService.rateDateSource[seleected].AdditionalCost =
              updatedArray[0].AdditionalCost;
            this.appService.rateDateSource[seleected].AdditionalCostItem =
              updatedArray[0].AdditionalCostItem;
            this.appService.rateDateSource[seleected].MautCost = mautData.cost;
            this.appService.rateDateSource[seleected].CountryID = mautData.item;
            this.appService.setRateTableData(updatedArray, ind, 'ftl');
            this.appService.exportTableFormatForFTL(res, ind);
            // }
          }
        });
      } else if (type === 43) {
        //fixed
        this.httpService.getFixedFTLTable(tableId).subscribe((res: any) => {
          if (res.length > 0) {
            let mautData: any = this.appService.onMautcountry(
              res[0]?.MautCountryCost,
              res[0]?.MautCountry
            );
            const updatedArray = res.map((obj: any) => {
              const {
                Distance,
                TrailerRateType,
                FTLMatrixCost,
                AdditionalCostItem,
                AdditionalCost,
                MautCountryCost,
                ...rest
              } = obj;
              return {
                FixedFTLDistance: Distance,
                FixedFTLTrailerRateType: TrailerRateType,
                FixedFTLCost: FTLMatrixCost,
                FixedFTLAdditionalCostItem: AdditionalCostItem,
                FixedFTLAdditionalCost: AdditionalCost,
                FixedFTLMautCost: mautData.cost,
                FixedFTLCountryID: mautData.item,
                ...rest,
              };
            });
            let seleected = this.appService.rateDateSource.findIndex(
              (item: any) => item?.RateTableID === tableId
            );
            this.appService.rateDateSource[seleected].FixedFTLAdditionalCost =
              updatedArray[0]?.FixedFTLAdditionalCost;
            this.appService.rateDateSource[seleected].FixedFTLMautCost =
              mautData.cost;
            this.appService.rateDateSource[
              seleected
            ].FixedFTLAdditionalCostItem =
              updatedArray[0]?.FixedFTLAdditionalCostItem;
            this.appService.rateDateSource[seleected].FixedFTLCountryID =
              mautData.item;
            this.appService.setRateTableData(updatedArray, ind, 'fixed');
            this.appService.exportTableFormatForFIxed(res, ind);
            // this.checOnAddiitonalCharge(updatedArray,ind, tableId)
          }
        });
      }
      if (ind === this.appService.rateTableList.length - 1) {
        setTimeout(() => {
          this.appService.enableExport = true;
          this.appService.raIsLoading = false;
        }, 4500);
      }
    });
  }

  onKeyDown(event: KeyboardEvent) {
    event.preventDefault();
  }

  valueChange(type: string) {
    let val = +this.rateTableForm.get('rateChange')?.value;
    val = type === 'add' ? val + 1 : val - 1;
    this.rateTableForm.get('rateChange')?.setValue(val);
    this.updateToDataSource();
  }

  onSelctOption(e: any) {
    if (e.name === 'gsdb') {
      this.carrierGSDBList = this.carrierGSDBList.filter(
        (item: any) => item.IsActive === true
      );
    } else if (e.name === 'bpReference') {
      this.bidpackRefList = this.bidpackRefList.filter(
        (item: any) =>
          item.IsActive === true && item.BidPackStatus !== 'Terminated'
      );
      this.bidpackRefList.sort((a: any, b: any) =>
        a.BidPackReference.toLowerCase() > b.BidPackReference.toLowerCase()
          ? 1
          : -1
      );
      if (this.bidpackRefList.length === 1) {
        this.rateTableForm.patchValue({
          bpReference: +this.bidpackRefList[0].BidPackID,
        });
        // this.onOptionChange({value:this.bidpackRefList[0].BidPackID},'bpReference')
        let selected = this.bidpackRefList[0];
        this.rateTableForm.patchValue({
          bpOriginRegion: this.onBPRegion(selected, 'OriginCountry'),
          bpOriginPostcode: this.onBPRegion(
            selected,
            'BidPackOriginZipCodeArea'
          ),
          bpDestination: selected.DestinationName,
        });
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginCountry = selected.OriginCountry;
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginZipCodeArea = selected.BidPackOriginZipCodeArea;
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackDestinationName = selected.DestinationName;
        this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
          +e.value;
      } else {
        let selected = this.bidpackRefList.find(
          (item: any) => item.BidPackID === Number(e.value)
        );
        this.rateTableForm.patchValue({
          bpReference: Number(e.value),
          bpOriginRegion: selected
            ? this.onBPRegion(selected, 'OriginCountry')
            : '',
          bpOriginPostcode: selected
            ? this.onBPRegion(selected, 'BidPackOriginZipCodeArea')
            : '',
          bpDestination: selected ? selected.DestinationName : '',
        });
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginCountry = selected ? selected.OriginCountry : '';
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackOriginZipCodeArea = selected
          ? selected.BidPackOriginZipCodeArea
          : '';
        this.appService.rateDateSource[
          this.appService.selectedItem
        ].BidPackDestinationName = selected ? selected.DestinationName : '';
        this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
          +e.value;
      }
      this.appService.updateValueToRateTable(
        'BidPackID',
        this.appService.selectedItem
      );
    }
  }

  onOptionChange(e: any, option: string) {
    if (option === 'bpReference') {
      let selected = this.bidpackRefList.find(
        (item: any) => item.BidPackID === Number(e.value)
      );
      this.rateTableForm.patchValue({
        bpOriginRegion: this.onBPRegion(selected, 'OriginCountry'),
        bpOriginPostcode: this.onBPRegion(selected, 'BidPackOriginZipCodeArea'),
        bpDestination: selected.DestinationName,
      });
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].BidPackOriginCountry = selected.OriginCountry;
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].BidPackOriginZipCodeArea = selected.BidPackOriginZipCodeArea;
      this.appService.rateDateSource[
        this.appService.selectedItem
      ].BidPackDestinationName = selected.DestinationName;
      this.appService.rateDateSource[this.appService.selectedItem].BidPackID =
        +e.value;
      this.appService.updateValueToRateTable(
        'BidPackID',
        this.appService.selectedItem
      );
      // console.log("e.value",e.value);
    } else if (option === 'fuelFlag') {
      this.fuelFlagSelected = e.value;
      [
        'excludingVat',
        'fuelPrice',
        'countryFuelPrice',
        'costBaseline',
        'costBreakdown',
        'fuelTrigger',
        'version',
      ].forEach((i: any) => {
        this.setAndRemoveValidator(
          i,
          this.fuelFlagSelected === 'No' ? false : true
        );
      });
      if (this.fuelFlagSelected === 'No') {
        this.rateTableForm.patchValue({
          costBaseline: null,
          costBreakdown: null,
          fuelTrigger: null,
          version: '',
          comment: '',
          fuelPrice: '',
          countryFuelPrice: '',
        });
      }
    }

    this.updateToDataSource();
  }

  setAndRemoveValidator(name: string, required: boolean) {
    this.rateTableForm
      .get(name)
      ?.setValidators(required ? Validators.required : null);
    this.rateTableForm.get(name)?.updateValueAndValidity();
  }

  onDragOver(e: any) {}
  onDragLeave(e: any) {}
  onDrop(e: any) {}

  onFileSelected(event: Event) {
    const selectedFiles: any = (event.target as HTMLInputElement).files;
    this.files = [];
    const allowedFormats = [
      'pdf',
      'docx',
      'doc',
      'xlsx',
      'xls',
      'ppt',
      'pptx',
      'csv',
      'txt',
      'png',
      'jpeg',
      'jpg',
    ];
    const maxSize = 500 * 1024; // 500KB

    if (selectedFiles) {
      const file = selectedFiles[0];
      const fileType = file.name.split('.').pop().toLowerCase(); // Get the file format

      // Check if the file format is allowed
      if (!allowedFormats.includes(fileType)) {
        this.httpService.openSnackBar(
          `Invalid file format. Allowed formats: ${allowedFormats.join(', ')}`
        );
        return; // Skip this file and move to the next one
      }

      // Check if the file size is within the limit
      if (file.size > maxSize) {
        this.httpService.openSnackBar('File size exceeds the limit of 500KB');
        return; // Skip this file and move to the next one
      }

      // Add the file to the files array
      this.files.push(file);
    }

    // Check if there are any valid files in the array
    if (this.files && this.files.length > 0) {
      const formData: FormData = new FormData();
      formData.append('files', this.files[0], this.files[0].name);

      // Make the API call using the valid file
      this.appService.isLoading = true;
      let agreementId =
        this.appService.rateDateSource[0]?.RateAgreementTableID === null
          ? 0
          : this.appService.rateDateSource[0]?.RateAgreementTableID;
      this.httpService
        .postRateFileToBlob(
          'version',
          agreementId ? agreementId : 0,
          this.appService.selectedItem,
          formData
        )
        .subscribe((res: any) => {
          this.appService.isLoading = false;
          if (res) {
            this.httpService.openSnackBar('File attached successfully..!');
            // if(this.operation === 'add'){
            // this.renameFileUpload();
            // }
          }
        });
    }
  }

  onSubmitChange() {
    this.applyRateCahnge = +this.rateTableForm.get('rateChange')?.value;
    // this.appService.applyRateChange(+this.rateTableForm.get('rateChange')?.value)
    if (
      this.appService.rateTableList[this.appService.selectedItem]
        ?.RateTableTypeID === 42
    ) {
      this.appService.applyCahngeEmitForFTL.emit(this.applyRateCahnge);
    } else if (
      this.appService.rateTableList[this.appService.selectedItem]
        ?.RateTableTypeID === 43
    ) {
      this.appService.applyCahngeEmitForFixed.emit(this.applyRateCahnge);
    } else if (
      this.appService.rateTableList[this.appService.selectedItem]
        ?.RateTableTypeID === 44
    ) {
      this.appService.applyCahngeEmitForLTL.emit(this.applyRateCahnge);
    }
  }

  downloadFile(file: File) {
    const blob = new Blob([file], { type: file.type });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = file.name;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  removeFile(i: any) {
    this.files = [];
  }
}
